module.exports = __webpack_public_path__ + "img/Menu-12.99fd26f6.png";